import { useCircleV4 } from "@/react/hooks/useCircleV4";

import { TextModifiersComponent } from "./TextModifiersComponent";
import { TextModifiersUIKitComponent } from "./TextModifiersUIKitComponent";
import type { TextModifiersMenuProps } from "./types";

export const TextModifiersMenu = (props: TextModifiersMenuProps) => {
  const { isCircleV4 } = useCircleV4();

  if (isCircleV4) {
    return <TextModifiersComponent {...props} />;
  }

  return <TextModifiersUIKitComponent {...props} />;
};
